module.exports = __webpack_public_path__ + "img/ArticlesofAssociationorAnnualReturn.224ee447.png";